import { render } from "./HelloWorld.vue?vue&type=template&id=649ef50f&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=649ef50f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-649ef50f"

export default script